import initSw from './Sw';
import initTracking from './Tracking';
import initDraggables from './Draggables';
import initFeatures from './Features';
import initAudio from './Audio';

const init = {
  ServiceWorker: initSw,
  Tracking: initTracking,
  Draggables: initDraggables,
  Features: initFeatures,
  Audio: initAudio,
};

export default init;
